import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import store from '../../../store';
import LocalStorage from '../../../components/DeviceStorage/LocalStorage';
import Utils from '../../../utils/Utils';

class UserFavoritedLive extends AbstractRequestTask {
    constructor() {
        super();
        const user = store.getState().user;
        this.user_token = user && user.user_token ? user.user_token : false;
        this.epg_version = LocalStorage.getItem('epgVersion') || false;
        this.region = user && user.region ? user.region : false;
        this.lasttouch = user && user.lasttouch && user.lasttouch.favorited ? user.lasttouch.favorited : false;
    }

    getEncType() {
        return 'application/x-www-form-urlencoded';
    }

    getUrl() {
        const http = "https://";
        const url = Launcher.get("akamai_mfwk");
        return `${http}${url}/services/user/v1/favorited`;
    }

    getParams() {
        const params = super.getParams();
        delete params.HKS;
        delete params.api_version;
        const lasttouchToggle = Utils.getApaMetadataKey('lasttouch_favoritedlive_toggle', '{"enable": false}', 'enable');
        const newParams = lasttouchToggle ?
        {
            ...params,
            epg_version: this.epg_version,
        } :
        {
          ...params,
          epg_version: this.epg_version,
        };
        return Object.assign({}, newParams);
    }

    getShowErrorModal(){
        return false;
    }

    getGETParams() {
      const params = super.getParams();
      const lasttouchToggle = Utils.getApaMetadataKey('lasttouch_favoritedlive_toggle', '{"enable": false}', 'enable')
      return ( 
          lasttouchToggle ?
          {
              ...params,
              ...{
                  epg_version: this.epg_version,
                  lasttouch: this.lasttouch
              }
          } :
          {
            ...params,
            epg_version: this.epg_version,
          }
      )
  }

    parseErrors(err) {
        console.log('[UserFav] - api errors' +  err);
    }

    getRetriesNumber() {
        return 0;
    }

    success(data, b) {
        this.resolve(data);
    }

    getHeaders() {
        return {
            'Content-Type': 'application/x-www-form-urlencoded'
        };
    }
}

export default UserFavoritedLive;


// WEBPACK FOOTER //
// ./src/requests/tasks/epg/UserFavoritedLive.js